import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const notifications = [{
  name: 'Martín',
  city: 'Buenos Aires',
  time: 'hace 2 min'
}, {
  name: 'Lucía',
  city: 'Córdoba',
  time: 'hace 5 min'
}, {
  name: 'Carlos',
  city: 'Rosario',
  time: 'hace 8 min'
}, {
  name: 'María',
  city: 'Mendoza',
  time: 'hace 12 min'
}, {
  name: 'Diego',
  city: 'La Plata',
  time: 'hace 15 min'
}, {
  name: 'Florencia',
  city: 'Tucumán',
  time: 'hace 18 min'
}, {
  name: 'Pablo',
  city: 'Mar del Plata',
  time: 'hace 22 min'
}, {
  name: 'Valentina',
  city: 'Salta',
  time: 'hace 25 min'
}, {
  name: 'Alejandro',
  city: 'Santa Fe',
  time: 'hace 30 min'
}, {
  name: 'Camila',
  city: 'Neuquén',
  time: 'hace 35 min'
}, {
  name: 'Sebastián',
  city: 'Bahía Blanca',
  time: 'hace 40 min'
}, {
  name: 'Julieta',
  city: 'San Juan',
  time: 'hace 45 min'
}];
export function SocialProofNotification() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const showNotification = () => {
      setCurrentIndex(prev => (prev + 1) % notifications.length);
      setVisible(true);
      setTimeout(() => setVisible(false), 5000);
    };
    // Show first one after 10 seconds
    const initialTimeout = setTimeout(showNotification, 10000);
    // Then every 40 seconds
    const interval = setInterval(showNotification, 40000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const current = notifications[currentIndex];
  return <AnimatePresence data-id="element-315">
      {visible && <motion.div initial={{
      opacity: 0,
      x: -80,
      y: 20
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -80
    }} transition={{
      type: 'spring',
      duration: 0.5,
      bounce: 0.3
    }} className="fixed bottom-4 left-4 z-40 max-w-xs" data-id="element-316">
          <div className="flex items-center gap-3 rounded-xl px-4 py-3 border border-white/10 shadow-2xl" style={{
        background: 'linear-gradient(135deg, #1a1a2e 0%, #0f0f1a 100%)',
        boxShadow: '0 8px 32px rgba(0,0,0,0.5), 0 0 15px rgba(255,153,0,0.1)'
      }} data-id="element-317">
            <div className="w-10 h-10 rounded-full flex items-center justify-center shrink-0 text-lg" style={{
          background: 'linear-gradient(135deg, #FF9900, #e68a00)'
        }} data-id="element-318">
              🛡️
            </div>
            <div className="flex flex-col" data-id="element-319">
              <p className="text-white text-sm font-bold leading-tight" data-id="element-320">
                {current.name} de {current.city}
              </p>
              <p className="text-gray-400 text-xs leading-tight" data-id="element-321">
                compró el MegaPack · {current.time}
              </p>
            </div>
            <button onClick={() => setVisible(false)} className="text-gray-500 hover:text-white text-xs ml-1 shrink-0 self-start mt-0.5" aria-label="Cerrar notificación" data-id="element-322">
              ✕
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}